import { render } from "./ServicesCardControl.vue?vue&type=template&id=31a23e5a&scoped=true"
import script from "./ServicesCardControl.vue?vue&type=script&lang=js"
export * from "./ServicesCardControl.vue?vue&type=script&lang=js"

import "./ServicesCardControl.vue?vue&type=style&index=0&id=31a23e5a&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a23e5a"]])

export default __exports__